import { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";

export const useCopy = () => {
  const [isCopied, setIsCopied] = useState(false);

  const [, copyToClipboard] = useCopyToClipboard();

  const copy = (text?: string | null) => {
    if (!text) return;
    copyToClipboard(text).then(() => setIsCopied(true));
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return {
    isCopied,
    copy,
  };
};
